import { toast } from "react-toastify";
import { VENTAS_API } from "../views/MainLayout/components/shared/services/ventas";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";

const initialVentas = []

export const ventasReducer = (state = initialVentas, action) => {
    switch(action.type){
        case "ventas/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchVentas = (isArchived, page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await VENTAS_API.get(isArchived, page, search)
        const data = await response.data;
        dispatch({ type: 'ventas/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}